import { render, staticRenderFns } from "./ImportExpedientsUploaderComponent.vue?vue&type=template&id=19c758e0&scoped=true"
import script from "./ImportExpedientsUploaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportExpedientsUploaderComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ImportExpedientsUploaderComponent.vue?vue&type=style&index=0&id=19c758e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c758e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c758e0')) {
      api.createRecord('19c758e0', component.options)
    } else {
      api.reload('19c758e0', component.options)
    }
    module.hot.accept("./ImportExpedientsUploaderComponent.vue?vue&type=template&id=19c758e0&scoped=true", function () {
      api.rerender('19c758e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/components/ImportExpedientsDialog/components/ImportExpedientsUploaderComponent.vue"
export default component.exports